import SimpleDialog from '@rio-cloud/rio-uikit/SimpleDialog';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router';

import { MARKETPLACE_ROUTE_PATH } from '../routes';
import { useDialogCloseTrackingLabel } from '../utils/useDialogCloseTrackingLabel';

interface Props {
    onClose?: () => void;
}

export function UnauthorizedDialog(props: Props) {
    const { onClose } = props;
    const [isClosed, setClosed] = useState(false);
    const dialogTitleId = 'intl-msg:marketplace.unauthorized.dialog.title';
    useDialogCloseTrackingLabel(!isClosed, 'marketplace.unauthorized.dialog.title');

    function handleClose() {
        if (onClose) {
            onClose();
        } else {
            setClosed(true);
        }
    }

    if (isClosed) {
        return <Navigate to={{ pathname: `/${MARKETPLACE_ROUTE_PATH}` }} />;
    }
    return (
        <SimpleDialog
            show={!isClosed}
            title={<FormattedMessage id={dialogTitleId} />}
            content={<FormattedMessage id='intl-msg:marketplace.unauthorized.dialog.message' />}
            onClose={handleClose}
        />
    );
}
